import { HelpLink, Related } from "./parts";

export function TrialsAndCredits() {
  return (
    <>
      <p>
        A trial gives a customer free usage up to a dollar credit or a number of tokens, between two dates. You add trials
        on the customer's <strong>Billing</strong> tab, under Trials and credits. The customer must be billed for the
        months the trial covers.
      </p>

      <h2>What a trial holds</h2>
      <table>
        <thead>
          <tr>
            <th>Field</th>
            <th>Meaning</th>
          </tr>
        </thead>
        <tbody>
          <tr>
            <td>Starts, ends</td>
            <td>UTC days, both included. With no start date, it starts the day you create it.</td>
          </tr>
          <tr>
            <td>Credit</td>
            <td>A dollar amount taken off the customer's price, up to $10,000,000.</td>
          </tr>
          <tr>
            <td>Token allowance</td>
            <td>Free tokens of any type.</td>
          </tr>
          <tr>
            <td>Models</td>
            <td>The models it covers. Empty means every model.</td>
          </tr>
        </tbody>
      </table>
      <p>A trial needs at least one limit: an end date, a credit or a token allowance.</p>

      <h2>How a trial is used</h2>
      <ul>
        <li>
          It credits the customer's <strong>price after the volume discount</strong>, so a customer is never credited more
          than they would have paid.
        </li>
        <li>With several trials, the one that started first is used first.</li>
        <li>
          In any month when a trial is active (its dates are open, something is left, and it is not cancelled), the monthly
          minimum is waived, even with no usage. A used-up trial does not waive it.
        </li>
        <li>Usage is never credited twice, even when a later month re-prices an earlier one.</li>
      </ul>
      <p>
        Example: a $500 credit from 1 to 30 September. The customer's September price is $620 after its volume discount.
        The trial credits $500, the invoice is $120, and the September minimum is waived.
      </p>

      <h2 id="burn-down">Burn-down</h2>
      <p>
        Open a trial to see its burn-down: how much credit or allowance each day used, what is left, and the projected date
        it runs out at the current pace. Amounts from closed months are final; the open month's are a preview.
      </p>

      <h2>Cancelling</h2>
      <p>
        <strong>Cancel</strong> stops a trial from the cancel day. A trial that a closed month has already used cannot be
        cancelled; let it end instead. A trial cannot start in a closed month.
      </p>
      <p>
        For a one-off amount off a single month, use a credit adjustment instead: <HelpLink to="usage-adjustments" />.
      </p>

      <Related to={["usage-adjustments", "rate-plans", "closing-a-month"]} />
    </>
  );
}
